import { render, staticRenderFns } from "./ModalNewGame.vue?vue&type=template&id=6450d59b&scoped=true&"
import script from "./ModalNewGame.vue?vue&type=script&lang=js&"
export * from "./ModalNewGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6450d59b",
  null
  
)

export default component.exports